import React from "react";
import { Grid, Pagination, Autoplay, Thumbs, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useLanguage, useWindowWide } from "hooks";
import GridList from "components/GridList";

function ScrollList({ loop, xs, sm, md, lg, xl, itemAs, items }) {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const Component = itemAs;
  const windowWide = useWindowWide();
  const breakpoints = React.useMemo(
    () => [
      { name: "xs", object: xs, width: 100 },
      { name: "sm", object: sm ? sm : xs, width: 576 },
      { name: "md", object: md ? md : sm ? sm : xs, width: 768 },
      { name: "lg", object: lg ? lg : md ? md : sm ? sm : xs, width: 992 },
      {
        name: "xl",
        object: xl ? xl : lg ? lg : md ? md : sm ? sm : xs,
        width: 1200,
      },
    ],
    [xs, sm, md, lg, xl]
  );
  const [currentBreakpoints, setCurrentBreakpoints] = React.useState(null);

  React.useEffect(() => {
    if (windowWide > 99) {
      let breakpoint;
      breakpoints.forEach((item) => {
        if (item.width < windowWide) breakpoint = item;
      });
      setCurrentBreakpoints(breakpoint);
    }
  }, [windowWide]);

  const settings = {
    modules: [Autoplay, Pagination, Grid, Thumbs, Navigation],
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: {},
    loop: loop,
    navigation: true,

    breakpoints: {
      ...(xs && {
        0: xs,
      }),
      ...(sm && {
        576: sm,
      }),
      ...(md && {
        768: md,
      }),
      ...(lg && {
        992: lg,
      }),
      ...(xl && {
        1200: xl,
      }),
    },
  };

  return (
    <div className="custom-slider">
      {currentBreakpoints &&
        (items.length > currentBreakpoints.object?.slidesPerView ? (
          <Swiper {...settings} dir={language.direction}>
            {items &&
              itemAs &&
              items.map((item, idx) => (
                <SwiperSlide key={idx}>
                  <div className="item-container">
                    <Component item={item} />
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        ) : (
          <GridList perRow={4} as={Component} items={items} />
        ))}
    </div>
  );
}

export default React.memo(ScrollList);
